<template>
    <div classs="peomonitor">
        <div class="monitor_center">
            <div class="block lf">
            <el-select v-model="value" placeholder="请选择" class="rf cascaderV"  @change="selectC" clearable >
                <el-option label="单选题" value="1"></el-option>
                <el-option label="多选题" value="5"></el-option>
                <el-option label="判断题" value="2" ></el-option>
                <el-option label="填空题" value="3"></el-option>
                <el-option label="简答题" value="4"></el-option>
            </el-select>
          </div>
        </div>
        <el-table :data="taskList" border style="width: 100%" class="analysis" 
        ref="multipleTable"
        >
        <el-table-column label="序号" width="76" type="index">
            </el-table-column>
        <el-table-column
            v-for="info in tHeadr" :key="info.key"     
            :property="info.key"
            :label="info.label"
            :width="info.width"
        >
        <template slot-scope="scope">
            {{scope.row[scope.column.property]}}  <!-- 渲染对应表格里面的内容 -->
        </template>
        </el-table-column>
        </el-table>
        <page :count="count" :Page.sync='page' @pagenation='pagetion'></page>
    </div>
</template>
<script>
import page from '../Common/page'

export default{
    name:'analysis',
    data(){
        return{
             taskList:[],
             value:'',
            id:this.$route.query.id,
            tHeadr: [
                {
                    label: '题型',
                    key: 'q_type',
                    width:'120  '
                },
                {
                    label: '所属题库',
                    key: 'model_name',
                    width:'166'
                },
                {
                    label:'题目',
                    key:'questions',
                    width:'640 '
                },
                {
                    label:'知识点',
                    key:'knowledge',
                    width:'221'
                },
                {
                    label:'难易程度',
                    key:'level',
                    width:'121'
                },
                {
                    label:'正确率',
                    key:'true',
                    width:'118'
                },
                {
                    label:'错误率',
                    key:'false',
                    width:'117'
                },
            ],
            limit:10, //一页几条数据
            count:0, //数据总计
            page:1, //当前页数
        }
    },
    components:{
        page,
    },
    props:{
         taskListSear:{
            type:Array,
            default:()=>[],
        },
    },
    methods:{
      pagetion(limit,page){
            var data={
                service:'Examtask.QsnAnalyze',
                id:this.id,
                limit:limit,
                page:page
            }
            var tklist=[]
            this.$axios.post(this.HOME,this.$qs.stringify(data))
            .then(res=>{
                if(res.data.data.code==1){
                 this.taskList=[]
                return false
            }
                this.count=res.data.data.info.count
                for(var i=0;i<res.data.data.info.list.length;i++){
                    tklist.push(res.data.data.info.list[i])
                    if(res.data.data.info.list[i].q_type==1){
                        var levelTxt='单选'
                    }
                    else if(res.data.data.info.list[i].q_type==2){
                        var levelTxt='判断'
                    }
                    else if(res.data.data.info.list[i].q_type==3){
                        var levelTxt='填空'
                    }
                    else if(res.data.data.info.list[i].q_type==4){
                        var levelTxt='简答'
                    }
                    else{
                        var levelTxt='多选'
                    }
                    if(res.data.data.info.list[i].level==1){
                        var levelUp='简单'
                    }
                    else if(res.data.data.info.list[i].level==2){
                        var levelUp='一般'
                    }
                    else if(res.data.data.info.list[i].level==3){
                        var levelUp='较难'
                    }
                    else{
                        var levelUp='困难'
                    }
                        tklist[i].level=levelUp
                        tklist[i].q_type=levelTxt
                }
                this.taskList=tklist
            })
                .catch(function (error) { // 请求失败处理
                console.log(error)
            });  
        },
        selectC(e){
        if(e!=''){
          var data={
            service:'Examtask.QsnAnalyze',
            id:this.id,
            limit:this.limit,
            page:this.page,
            qtype:e
        }
        var tklist=[]
        this.$axios.post(this.HOME,this.$qs.stringify(data))
        .then(res=>{
            if(res.data.data.code==1){
                 this.taskList=[]
                return false
            }
             this.count=res.data.data.info.count
            for(var i=0;i<res.data.data.info.list.length;i++){
                tklist.push(res.data.data.info.list[i])
                if(res.data.data.info.list[i].q_type==1){
                    var levelTxt='单选'
                }
                else if(res.data.data.info.list[i].q_type==2){
                    var levelTxt='判断'
                }
                else if(res.data.data.info.list[i].q_type==3){
                    var levelTxt='填空'
                }
                else if(res.data.data.info.list[i].q_type==4){
                    var levelTxt='简答'
                }
                else{
                    var levelTxt='多选'
                }
                if(res.data.data.info.list[i].level==1){
                    var levelUp='简单'
                }
                else if(res.data.data.info.list[i].level==2){
                    var levelUp='一般'
                }
                else if(res.data.data.info.list[i].level==3){
                    var levelUp='较难'
                }
                else{
                    var levelUp='困难'
                }
                    tklist[i].level=levelUp
                    tklist[i].q_type=levelTxt
            }
            this.taskList=tklist
        })
        }
        else{
          var data={
            service:'Examtask.QsnAnalyze',
            id:this.id,
            limit:this.limit,
            page:this.page
        }
        var tklist=[]
        this.$axios.post(this.HOME,this.$qs.stringify(data))
        .then(res=>{
            if(res.data.data.code==1){
                 this.taskList=[]
                return false
            }
            this.count=res.data.data.info.count
            for(var i=0;i<res.data.data.info.list.length;i++){
                tklist.push(res.data.data.info.list[i])
                if(res.data.data.info.list[i].q_type==1){
                    var levelTxt='单选'
                }
                else if(res.data.data.info.list[i].q_type==2){
                    var levelTxt='判断'
                }
                else if(res.data.data.info.list[i].q_type==3){
                    var levelTxt='填空'
                }
                else if(res.data.data.info.list[i].q_type==4){
                    var levelTxt='简答'
                }
                else{
                    var levelTxt='多选'
                }
                if(res.data.data.info.list[i].level==1){
                    var levelUp='简单'
                }
                else if(res.data.data.info.list[i].level==2){
                    var levelUp='一般'
                }
                else if(res.data.data.info.list[i].level==3){
                    var levelUp='较难'
                }
                else{
                    var levelUp='困难'
                }
                    tklist[i].level=levelUp
                    tklist[i].q_type=levelTxt
            }
            this.taskList=tklist
        })
        }
      },
    },
    watch:{
        taskListSear(){
            this.taskList=this.taskListSear
            console.log(this.taskListSear)
        }
    },
    mounted(){
        var data={
            service:'Examtask.QsnAnalyze',
            id:this.id,
            limit:this.limit,
            page:this.page
        }
        var tklist=[]
        this.$axios.post(this.HOME,this.$qs.stringify(data))
        .then(res=>{
            this.count=res.data.data.info.count
            for(var i=0;i<res.data.data.info.list.length;i++){
                tklist.push(res.data.data.info.list[i])
                if(res.data.data.info.list[i].q_type==1){
                    var levelTxt='单选'
                }
                else if(res.data.data.info.list[i].q_type==2){
                    var levelTxt='判断'
                }
                else if(res.data.data.info.list[i].q_type==3){
                    var levelTxt='填空'
                }
                else if(res.data.data.info.list[i].q_type==4){
                    var levelTxt='简答'
                }
                else{
                    var levelTxt='多选'
                }
                if(res.data.data.info.list[i].level==1){
                    var levelUp='简单'
                }
                else if(res.data.data.info.list[i].level==2){
                    var levelUp='一般'
                }
                else if(res.data.data.info.list[i].level==3){
                    var levelUp='较难'
                }
                else{
                    var levelUp='困难'
                }
                    tklist[i].level=levelUp
                    tklist[i].q_type=levelTxt
            }
            this.taskList=tklist
        })
    }
}
</script>


// WEBPACK FOOTER //
// src/components/task/analysis.vue